import React from 'react'
import IhubProposal from "../assets/pdf/callForPurpose/AnaVu_Workshop_2025_program_list.pdf";
const TestPage = () => {
  return (
    <div>
      <h1>Test Page</h1>
      <a href={IhubProposal} target="_blank" rel="noopener noreferrer">
        Download IHub Proposal
      </a>
    </div>
  )
}

export default TestPage;